var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7598 11.8206V29.9804C59.7598 46.5186 48.5289 60.9392 32.4866 65C16.4712 60.9526 5.24023 46.5186 5.24023 29.9804V11.8206C17.8516 10.4 24.9949 5.60206 32.5 0C40.0052 5.60206 47.1485 10.4 59.7598 11.8206Z",
    fill: "#139184"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 57.8293C20.4248 53.9964 12.1289 42.7922 12.1289 29.9799V17.6768C20.6124 15.8273 26.8444 12.4098 32.5 8.50977C38.2763 12.517 44.3877 15.8675 52.8712 17.6902V29.9933C52.8712 42.7922 44.5753 53.9964 32.5 57.8293Z",
    fill: "#63ACA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6107 43.723L20 36.1124L23.8585 32.2387L27.6107 35.9757L41.6015 22L45.46 25.8585L27.6107 43.723Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpVerificationIcon);
export default __webpack_public_path__ + "static/media/OTP-verification-icon.f689673f571ba26190b3fea905a79de9.svg";
export { ForwardRef as ReactComponent };